import React from 'react';

const SvgHistory = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="14"
    viewBox="0 0 16 14"
    fill="none"
    {...props}
  >
    <path
      d="M9.14286 0.140625C5.35619 0.140625 2.28571 3.2111 2.28571 6.99777H0L2.96381 9.96158L3.01714 10.0682L6.09524 6.99777H3.80952C3.80952 4.0492 6.19429 1.66443 9.14286 1.66443C12.0914 1.66443 14.4762 4.0492 14.4762 6.99777C14.4762 9.94634 12.0914 12.3311 9.14286 12.3311C7.67238 12.3311 6.33905 11.7292 5.37905 10.7616L4.29714 11.8435C5.53905 13.0854 7.24572 13.8549 9.14286 13.8549C12.9295 13.8549 16 10.7844 16 6.99777C16 3.2111 12.9295 0.140625 9.14286 0.140625ZM8.38095 3.95015V7.75967L11.619 9.67967L12.2057 8.70443L9.52381 7.11205V3.95015H8.38095Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgHistory;
